import React from "react";
import Footer from "../../Footer/Footer";
import Navigation from "../Navigation/Navigation";

const Cart = () => {
  return (
    <div>
      <Navigation />
      <div>
        <h2 className="text-center display-4 text-success my-5">
          Cart is Comming Soon!
        </h2>
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
